import * as client from './client.js';

/**
 * Retrieve a single unit
 */
export async function getUnit(id) {
    return await client.get(`/units/${id}`);
}

/**
 * Retrieve a list of units.
 */
export async function getUnitsList() {
    return await client.get('/units');
}

/**
 * Retrieve a list of units unfiltered by org.
 */
export async function getUnfilteredUnitsList() {
    return await client.get('/units/unfiltered');
}

/**
 * Delete a unit
 */
export async function deleteUnit(id) {
    return await client.delete(`/units/${id}`);
}

/**
 *  Retrieve list of all images usable for sensor containers
 */
export async function getSensorImageList() {
    return await client.get('/list_container_images');
}

/**
 * Retrieve a list of cellular carriers.
 */
export async function getCellularCarriersList() {
    return await client.get('/units/cellular_carriers');
}

/**
 *  Retrieve list of all Gateway Firmware update names
 */
export async function getFirmwareUpdateList() {
    return await client.get('/list_firmware_files');
}

/**
 *  Retrieve list of all unit organizations
 */
export async function getUnitOrganizations() {
    return await client.get('/units/unit_organizations');
}

export async function getUnitOrganization(orgId) {
    return await client.get(`/units/organization_units/${orgId}`);
}

/**
 *  Retrieve SAS token to the OTA store
 */
export async function getOTASAS() {
    return await client.get('/get_ota_sas');
}

/**
 * Update endpoint for changing the UI data properties
 */
export async function updateUiData(id, uiData) {
    return await client.post(`/units/${id}/ui_data`, uiData);
}

/**
 * Arms the given unit
 */
export async function armUnit(id) {
    return await client.post(`/units/${id}/arm`, null);
}

/**
 * Disarms the given unit
 */
export async function disarmUnit(id) {
    return await client.post(`/units/${id}/disarm`, null);
}

// /**
//  * Sets a flag so that the next time the user recieves a command, it will lock itself in high power mode
//  */
// export async function latchHighPower(id) {
//     return await client.post(`/units/${id}/latch_power_mode_high`, null);
// }

// /**
//  * Unlatches the unit from high power mode if it was already latched next time the unit receives a command
//  */
// export async function unlatchHighPower(id) {
//     return await client.post(`/units/${id}/unlatch_power_mode_high`, null);
// }

export async function setCheckinTimes(id, norm_checkin_sec, ext_checkin_sec) {
    return await client.post(`/units/${id}/set_checkin_times`, {
        norm_checkin_sec,
        ext_checkin_sec,
    });
}

/**
 * Changes the power mode for the unit
 */
export async function setPowerMode(id, mode) {
    return await client.post(`/units/${id}/set_power_mode`, {
        power_mode: mode,
    });
}

/**
 * Change whether to latch high on shore power
 * latchHigh: boolean
 */
export async function setShorePowerLatch(id, latchHigh) {
    return await client.post(`/units/${id}/set_shore_power_latch`, {
        shore_power_latch: latchHigh,
    });
}

/**
 * Disarm the unit and put it into the STANDBY power mode
 */
export async function disarmAndStandby(id) {
    return await client.post(`/units/${id}/disarm_and_standby`, null);
}

/**
 * Confirm provisioning of unit with given name
 */
export async function provision(id, unit) {
    return await client.post(`/units/${id}/provision`, unit);
}

/**
 * Update the sensor configs of one or more sensors on a particular unit
 */
export async function setSensorConfigs(id, configs) {
    return await client.post(`/units/${id}/sensor_configs`, configs);
}

/**
 * Set the list of the unit's managers.
 * Body:
 *   [
 *       { "user_id": 4 }
 *   ]
 *
 * Note: Other fields may be present in the elements, but only the user_id is used.
 */
export async function setManagers(id, managers) {
    return await client.post(`/units/${id}/managers`, managers);
}

export async function setOrganizations(id, organizations) {
    return await client.post(`/units/${id}/organizations`, organizations);
}

export async function setCellularCarrier(id, carrier) {
    return await client.post(`/units/${id}/set_cellular_carrier`, {
        cellular_carrier: carrier,
    });
}

export async function setCanConfig(id, config) {
    return await client.post(`/units/${id}/set_can_config`, {
        can_config: config,
    });
}

export async function setPendingFirmware(id, firmwareFileName) {
    return await client.post(`/units/${id}/set_pending_firmware`, {
        firmware: firmwareFileName,
    });
}

export async function sendSMSWake(id) {
    return await client.post(`/units/${id}/send_sms_wake`);
}
